import { Component, EventEmitter, Injectable, Input, Output } from '@angular/core';
import { ApplicationItem } from '../../model/ApplicationItem';
import { ValueItem } from '../../model/ValueItem';
import { ConfigurationService } from '../../services/configuration.service';
import { AlertService } from '../../../shared/alert/services/alert.service';
import { CodeEditorMode, EditorEvent } from './configurationEditor.component';
import { IsJson, MinifyJson, TryParseJsonWithErrorDetails } from '../../../shared/utils/json.utils';

type MessageType = 'error' | 'warning' | 'success' | 'info';

@Component({
  selector: 'app-configuration-create-value-form',
  templateUrl: '../templates/configurationCreateValueForm.component.html',
})
@Injectable()
export class ConfigurationCreateValueFormComponent {
  @Input() Value: ValueItem;

  @Output() OnSubmit = new EventEmitter<{ isSuccess: boolean, data?: any }>();

  editorMode: CodeEditorMode;

  message: { type: MessageType, content: string } | null = null;

  constructor(private configurationService: ConfigurationService, private alertService: AlertService) { }

  SaveValue() {
    this.alertService.removeAll();
    if (!this.Value || !this.Value.Application.Id || !this.Value.Key  || !this.Value.Value) {
      this.alertService.add('danger', 'Please complete empty fields!');
      return;
    }

    if (!this.isValidValue()) {
      return;
    }

    const isJson = IsJson(this.Value.Value);
    const canSave = !isJson || this.validateIfJsonAndSetMessage();

    if (canSave) {
      this.Value.Value = isJson ? MinifyJson(this.Value.Value) : this.Value.Value;
      this.configurationService.EditOrCreateValue(this.Value)
        .subscribe(
          () => this.OnSubmit.emit({ isSuccess: true }),
          err => this.OnSubmit.emit({ isSuccess: false, data: err })
        );
    }
  }

  OnEditorEvent(event: EditorEvent) {
    if (event && event.type === 'syntaxError') {
      this.message = { type: 'error', content: event.data };
    }
  }

  OnEditorModeChange(newMode: CodeEditorMode) {
    this.editorMode = newMode;

    const isJsonMode = this.editorMode === 'json';

    if (isJsonMode) {
      this.validateIfJsonAndSetMessage();
    } else {
      this.message = { type: 'info', content: 'The config is not a json. No need to validate it' };
    }
  }

  OnEditorTextChange(newText: string) {
    this.setTextInValue(newText);
    this.validateIfJsonAndSetMessage();
  }

  selectApplication(value: ApplicationItem): void {
    this.Value.Application.Id = value ? value.Id : '';
  }

  private isValidValue() {
    const isValid = this.Value && this.Value.Value && this.Value.Key && this.Value.Application.Id;
    return isValid;
  }

  private setTextInValue(text: string) {
    this.Value.Value = text;
  }

  private validateIfJsonAndSetMessage() {
    if (this.editorMode !== 'json') {
      return false;
    }

    const [isValidJson, errorMessage] = this.validateJson();
    this.message = isValidJson
      ? { type: 'success', content: 'The Json is valid' }
      : { type: 'error', content: errorMessage };
    return isValidJson;
  }

  private validateJson(): [boolean, string | null] {
    const [isValidJson, errorMessage] = TryParseJsonWithErrorDetails(this.Value.Value);
    return [isValidJson, errorMessage];
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/configurationCreateValueForm.component.ts